import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { routes } from "Projects/config/routes";
const {
  createProject: { path },
} = routes;
export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([import("./CreateProject.js")]).then(
          ([importedModule0]) => {
            const component = importedModule0.default;
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
  };
};
